// @ts-nocheck
import { CurrencyPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { dateTrim } from '@lbca-shared/helpers/formats';
import { IconComponent } from '@lbca-shared/icon';
import {
  flatten as flattenRamda,
  has as hasRamda,
  ifElse as ifElseRamda,
  map as mapRamda,
  path as pathRamda,
  pipe as pipeRamda,
  prop as propRamda,
} from 'ramda';
import { Subscription } from 'rxjs';
import { v1 as uuidV1 } from 'uuid';
import { NgTryForDirective } from '../../../../../directives/_old_directives/ng-try-for.directive';
import { MaskCurrencyBr } from '../../../../../helpers/_old_helpers/masks/currency_br';
import { MaskCurrencyUs } from '../../../../../helpers/_old_helpers/masks/currency_us';
import { DatePickerComponent } from '../../../fields/date-picker/date-picker.component';
import { DateTimePickerComponent } from '../../../fields/date-time-picker/date-time-picker.component';
import { FileFromProcessComponent } from '../../../fields/file-from-process/file-from-process.component';
import { GridboxUniqueComponent } from '../../../fields/gridbox-unique/gridbox-unique.component';
import { InputHiddenComponent } from '../../../fields/input-hidden/input-hidden.component';
import { InputProcessNumberComponent } from '../../../fields/input-process-number/input-process-number.component';
import { InputRadioComponent } from '../../../fields/input-radio/input-radio.component';
import { InputReferenceComponent } from '../../../fields/input-reference/input-reference.component';
import { InputTextCondensedComponent } from '../../../fields/input-text-condensed/input-text-condensed.component';
import { InputTextComponent } from '../../../fields/input-text/input-text.component';
import { MessageFieldComponent } from '../../../fields/message-field/message-field.component';
import { SelectTreeCondensedComponent } from '../../../fields/select-tree-condensed/select-tree-condensed.component';
import { SelectComponent } from '../../../fields/select/select.component';
import { TableListComponent } from '../../../fields/table-list/table-list.component';
import { TextareaComponent } from '../../../fields/textarea/textarea.component';
import { TimePickerRefComponent } from '../../../fields/timepicker/timepicker.component';
import { TreeTableComponent } from '../../../fields/tree-table/tree-table.component';
import { TableComponent } from '../../../table/table.component';
import { Table } from '../../../table/table.model';
import { ISubForm } from '../../dynamic-form.model';
import { DynamicFormService } from '../../dynamic-form.service';
import { ClaimService } from '../claim/claim.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { FormTemplateService } from '../form-template/form-template.service';
import { EntityFieldsComponent } from '../sub-form/entity-fields/entity-fields.component';
import { tableHeader } from './cco-v2-table';
import { CcoService } from './cco.service';

class CcoFormService extends DynamicFormService {
  public override initializeFieldControlValues(fieldValues: { [x: string]: any }) {
    this.externalData = fieldValues;
    for (const key of Object.keys(fieldValues)) {
      if (
        this.formControlStructure.fieldControl[key] &&
        !this.formControlStructure.fieldControl[key].initialized
      ) {
        this.formControlStructure.fieldControl[key].value = fieldValues[key];
      }
    }

    for (const fieldKey of Object.keys(this.formControlStructure.fieldControl)) {
      if (!this.formControlStructure.fieldControl[fieldKey].value) {
        this.formControlStructure.fieldControl[fieldKey].initialized = true;
      }
    }
  }
}

@Component({
  selector: 'lbca-cco-v2',
  templateUrl: './cco-v2.component.html',
  styleUrls: ['./cco-v2.component.scss', '../sub-form/subform.component.scss'],
  providers: [CcoFormService],
  imports: [
    InputRadioComponent,
    NgClass,
    TableComponent,
    SelectComponent,
    forwardRef(() => InputTextComponent),
    NgTryForDirective,
    NgTemplateOutlet,
    forwardRef(() => InputHiddenComponent),
    forwardRef(() => InputProcessNumberComponent),
    forwardRef(() => InputReferenceComponent),
    forwardRef(() => InputTextCondensedComponent),
    forwardRef(() => TextareaComponent),
    forwardRef(() => DateTimePickerComponent),
    forwardRef(() => DatePickerComponent),
    forwardRef(() => TimePickerRefComponent),
    forwardRef(() => TreeTableComponent),
    forwardRef(() => EntityFieldsComponent),
    forwardRef(() => SelectTreeCondensedComponent),
    forwardRef(() => GridboxUniqueComponent),
    forwardRef(() => TableListComponent),
    forwardRef(() => MessageFieldComponent),
    forwardRef(() => FileUploadComponent),
    forwardRef(() => FileFromProcessComponent),
    forwardRef(() => CurrencyPipe),
    IconComponent,
  ],
})
export class CcoV2Component implements OnInit {
  public disabled;
  public dismemberOptions;
  public letterIdList;
  public totalValueRequest;
  public hasError;
  public artifactsConfig = {};
  public requestConfig = {};
  public fields: ISubForm['fields'] | undefined = [];
  public optionsSelected: any[] = [];
  public errors: any = {};
  public dynamicFormService;
  public processId!: string;
  public options: any[] = [];
  public requestList: any[] = [];
  public dismemberList: any[] = [];
  public valueField = { type: undefined, value: undefined, id: undefined };
  public letterLabels;
  public showDismemberment = false;
  public subFormModuleInstance;
  public data: Record<string, unknown> = {};
  public dataAttr;
  public table: Table = {
    body: [],
    columns: [],
  };
  public initialized = true;
  public typeLegalRequest;
  public entityKey = '';
  public loaded = false;

  saveSubscription!: Subscription;

  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
  }
  public labelConfig = {};
  @Input('properties') set templateFields(properties) {
    this.artifactsConfig = properties.config?.artifacts;
    this.labelConfig = properties.config?.labelConfig;
    this.requestConfig = properties.config?.request;
    this.fields = properties.fields;
    this.entityKey = properties.entityKey;
  }
  @Input('dataAttr') set dataAttibutes(data) {
    this.processId = data.processNumber;
    this.dataAttr = data;
  }
  @Input('origin') set disable(value) {
    if (value === 'task-form-complete') {
      this.disabled = true;
    }
  }

  @Input('cardData') cardInfo;

  @Input('entityData') set modulesConfig(data) {
    if (data) {
      this.data = { ...this.data, ...data };
    }
  }

  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();
  @Output('errorApi') errorApiEmmiter = new EventEmitter();
  constructor(
    private formTemplateService: FormTemplateService,
    public maskcurrencyBr: MaskCurrencyBr,
    private maskCurrencyUs: MaskCurrencyUs,
    private claimService: ClaimService,
    public ccoForm: CcoFormService,
    private ccoService: CcoService
  ) {}

  ngOnInit(): void {
    // this.getLetterByProcessId();
    this.getOptionsDismember();
    // this.getLabelTypeLegalRequest();
    this.validateCallbackEmitter.emit(this.validateCallbackFields);
    this.ccoForm.convertSubformsToControlStructure([
      {
        id: '9e04b0e5-0394-4faf-86ac-2dbd9a662a54',
        disable: false,
        label: 'CCO',
        fields: this.fields,
        type: 'SUBFORM',
        entityId: 'cco',
        entityKey: 'cco',
      },
    ]);

    this.subFormModuleInstance = this.ccoForm.setFormControlData(
      '9e04b0e5-0394-4faf-86ac-2dbd9a662a54'
    );
    this.ccoService.getCcoDraft(this.dataAttr.bpmIdCard).subscribe(
      (resp: any) => {
        if (resp) {
          this.data = { ...this.data, ...resp };
        }
        this.ccoForm.initializeFieldControlValues(this.data);

        this.fields?.forEach((row) => {
          row.forEach((field) => {
            const { entityKey, entityRecoverKey } = field;
            this.subFormModuleInstance(entityKey, 'valid', true);
            if (entityRecoverKey) {
              this.subFormModuleInstance(
                entityKey,
                'propertiesValued',
                this.data[entityRecoverKey]
              );
            }
          });
        });

        this.getRequests(resp);
      },
      (err: any) => {
        console.log(err);
      }
    );
    this.ccoForm.setPageIniciated();
    this.saveSubscription = this.ccoForm.saveEmitter.subscribe((data) => {
      this.saveDraft(data);
    });
  }

  getRequests(draft) {
    const processId = this.processId;
    const context = 'legalRequest';

    const params = {
      taskId: 'base',
      processId,
      context,
    };

    this.claimService.request<any[]>(params).subscribe(
      (resp: any[]) => {
        if (draft && draft['requestIdList']?.length > 0) {
          const { requestIdList } = draft;
          const requestArray: any = [];
          requestIdList.forEach((id) => {
            const found = resp.find((request) => request.id === id);
            if (found) {
              requestArray.push(found);
            }
          });
          this.options = requestArray;
        }
        this.requestList = resp.filter(
          (request) => !request.pay_date && request.referenceId && request.primaryValue
        );
        let unlock = true;
        if (this.requestList.length === 0) {
          unlock = false;
        } else {
          this.getRequestLabels();
        }
        this.dynamicFormService.unlockDynamicFormEmitter.emit(unlock);
        this.dynamicFormService.setPageIniciated();
        this.dynamicFormService.setTimeOutToSaveData(this.entityKey, unlock);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  calculateTotal() {
    const totalValue = this.options.reduce((acc, element: any) => {
      return acc + Number(element.endValue);
    }, 0);
    return totalValue;
  }

  getRequestLabels() {
    const { flowId } = this.cardInfo;
    const params = {
      tableName: `legal-request-type`,
      context: flowId,
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>('/legal-request/drop-data', params)
      .subscribe((resp: Array<any>) => {
        this.typeLegalRequest = resp;
        this.requestList.forEach((request) => {
          const type = this.typeLegalRequest.find((type) => type.id === request.typeId);
          if (type) {
            request.label =
              type.label +
              (request.primaryValue
                ? ' | ' + this.setMask(this.maskcurrencyBr, request.primaryValue)
                : '');
          }
        });
        this.loaded = true;
      });
  }

  formatLabel(letterRequest: { [key: string]: any }): string {
    const { typeId } = letterRequest;
    const requestLabel: string = this.getLabel(typeId, this.typeLegalRequest);
    return `${requestLabel}`;
  }

  getLabel(id: string, arr: Array<any>) {
    if (!arr) return;
    const item = arr.filter((e) => e.id === id);
    return item[0].label;
  }

  getlebelLetter() {
    const params = {
      tableName: this.labelConfig['tableName'],
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>('/task/drop-data', params)
      .subscribe((resp: Array<any>) => {
        this.letterLabels = resp;
      });
  }

  getLetterByProcessId() {
    const params = {
      tableName: this.artifactsConfig['tableName'],
      processId: this.processId,
      entityKey: this.artifactsConfig['entityKey'],
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>(this.artifactsConfig['entityRecoverUrl'], params)
      .subscribe((resp: Array<any>) => {
        if (resp.length !== 0) {
          resp.map((artifact) => {
            const payList = artifact[this.artifactsConfig['entityKey']].map((payList) => ({
              ...payList,
              referenceId: artifact.id,
              letter_type: artifact.letter_type,
            }));

            if (payList.length !== 0) {
              this.requestList.push(...payList);
            }
          });
        }
      });
  }

  mountTable(body: Array<any>) {
    const requestListFormatted = JSON.parse(JSON.stringify(this.options));

    requestListFormatted.forEach((element) => {
      if (element.primaryValue || element.endValue) {
        element.primaryValue = this.setMask(this.maskcurrencyBr, element.primaryValue);
        element.endValue = this.setMask(this.maskcurrencyBr, element.endValue);
      }
      if (element.primaryValueUS) {
        element.primaryValueUS = this.setMask(this.maskCurrencyUs, element.primaryValueUS);
      }
      if (element.id) {
        element.id = this.getLabel(element.typeId, this.typeLegalRequest);
      }
      if (element.dateReference) {
        element.dateReference = dateTrim(new Date(element.dateReference * 1000));
      }
    });
    this.table = {
      columns: tableHeader,
      body: requestListFormatted,
    };
    return this.table;
  }

  setMask(mask: any, value: string) {
    value = mask.setMask(value, 0).formatedValue;
    return value;
  }

  getOptionsDismember() {
    const params = {
      tableName: 'legal-request-dismemberment-type',
      context: this.cardInfo['flowId'],
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>('/legal-request/drop-data', params)
      .subscribe((resp: Array<any>) => {
        this.dismemberOptions = resp;
      });
  }

  removeItem(id: string, arr: Array<any>) {
    const index = arr.findIndex((e) => e.id === id);
    if (index > -1) {
      arr.splice(index, 1);
    }
    this.ccoForm.setPageIniciated();
    this.ccoForm.setTimeOutToSaveData('dismemberList', this.dismemberList);
  }

  changeLabelValue(event) {
    const itemId = event;

    const item = this.requestList.filter((value) => value.id === itemId)[0];
    this.optionsSelected = [item];
    // if (event.target.checked) {
    //   const item = this.requestList.filter((value) => value.id === itemId)[0];
    //   this.optionsSelected.push(item);
    // } else {
    //   this.removeItem(itemId, this.optionsSelected);
    // }
  }

  back() {
    this.optionsSelected = [];
    this.options = [];
    this.totalValueRequest = [];
    this.dismemberList = [];
    this.errors = [];
    this.ccoForm.setPageIniciated();
    this.ccoForm.setTimeOutToSaveData('dismemberList', undefined);
    this.ccoForm.setTimeOutToSaveData('requestIdList', undefined);
  }

  selectItems() {
    this.ccoForm.setPageIniciated();
    this.options = [...this.optionsSelected];
    this.ccoForm.setTimeOutToSaveData(
      'requestIdList',
      this.options.map((op) => op.id)
    );
    this.ccoForm.setPageIniciated();
    this.ccoForm.setTimeOutToSaveData('dismemberList', this.formatDismemberValue());
  }

  changeValue(event, key) {
    this.valueField[key] = event;
  }

  checkValue(inputValue: string) {
    const requestValue = this.calculateTotal();

    const totalDismember = this.dismemberList.reduce((acc, element: any) => {
      return acc + Number(element.value);
    }, 0);
    const result = totalDismember + Number(inputValue);

    if (Number(inputValue) > Number(requestValue) || result > Number(requestValue) || !inputValue) {
      this.errors = ['Valor adicionado maior que o valor total de solicitações'];
      return false;
    } else {
      this.errors = [];
      return true;
    }
  }

  addField(requests: { [key: string]: any }[]) {
    const item = {
      id: uuidV1(),
      type: this.valueField.type,
      value: this.valueField.value,
      paymentIds: requests.map((payList: any) => ({ paymentId: payList.id })),
    };
    if (this.valueField?.value && this.checkValue(this.valueField?.value)) {
      this.dismemberList.push(item);
      this.ccoForm.setPageIniciated();
      this.ccoForm.setTimeOutToSaveData('dismemberList', this.formatDismemberValue());
    }
  }

  getLabelTypeLegalRequest() {
    const params = {
      context: this.requestConfig['context'],
      parent: 0,
    };
    this.formTemplateService.getDinamicUrl('legal-request/drop-data', params).subscribe((resp) => {
      this.typeLegalRequest = resp;
    });
  }

  toggleInputs() {
    this.showDismemberment = !this.showDismemberment;
  }

  public validateCallbackFields = () => {
    this.hasError = false;

    if (!this.options || this.options.length === 0) {
      this.hasError = true;
    }

    let emptyArray;

    const { fieldControl } = this.ccoForm.formControlStructure;

    const allFieldsThisModule = pipeRamda(
      pathRamda(['fields']),
      flattenRamda as any,
      mapRamda(
        ifElseRamda(
          hasRamda('entityColumnName'),
          propRamda('entityColumnName'),
          propRamda('entityKey') as any
        )
      )
    )(this);
    allFieldsThisModule.forEach((key: any) => {
      const field = fieldControl[key];

      if (typeof field?.value === 'object') {
        emptyArray = fieldControl[key];
      }

      if (field?.required && field?.visible) {
        this.validationCallback();
        this.subFormModuleInstance(key, 'error', []);
        if (
          !field.value ||
          (typeof field?.value === 'object' && emptyArray && emptyArray.value.length === 0)
        ) {
          if (typeof field.value === 'boolean') {
            if (String(field.value).length === 0) {
              this.subFormModuleInstance(key, 'error', ['Campo Obrigatório!']);
              this.hasError = true;
            }
          } else {
            this.subFormModuleInstance(key, 'error', ['Campo Obrigatório!']);
            this.hasError = true;
          }
        }
      }
      if (!field?.visible) {
        this.validationCallback();
        this.subFormModuleInstance(key, 'error', []);
      }
    });

    return this.hasError;
  };

  formatDismemberValue() {
    return this.dismemberList
      ? this.dismemberList.map((dis) => ({
          id: dis.id,
          value: dis.value,
          type: dis.type,
        }))
      : [];
  }

  saveUpload(event) {
    const value = event.context;
    const entityKey = event.entityKey;
    this.subFormModuleInstance(entityKey, 'value', value);
  }

  saveDraft(data) {
    const params = {
      processId: this.processId,
      taskId: this.dynamicFormService.taskId,
    };

    this.ccoService.saveDraft<any[]>(data, params).subscribe(
      (resp: any[]) => {},
      (err: any) => {
        console.log(err);
      }
    );
  }

  public erroApi(event) {
    this.errorApiEmmiter.emit(event);
  }

  private fieldsValidations: unknown[] = [];

  public setValidationCallback(fn, key) {
    this.fieldsValidations[key] = fn;
  }

  public validationCallback = () => {
    Object.keys(this.fieldsValidations).forEach((key) => this.fieldsValidations[key]());
  };
}
